
@if(selectedCable().csa().value() > 0) {

<form class="mce-form-field-group">

    <div class="mce-form-field-group">


        @if(!isArmouredRx.isLoading() && isArmoured()) {
        <div>
            <mat-checkbox [formField]="form().armourBonded">Armour Bonded</mat-checkbox>
        </div>
        }


        @if(!isScreenedRx.isLoading() && isScreened()) {
        <div>
            <mat-checkbox [formField]="form().screenBonded">Screen Bonded</mat-checkbox>
        </div>
        }


        @if(!hasSpareCoreRx.isLoading() && hasSpareCore()) {
        <div>
            <mat-checkbox [formField]="form().useSpareCoreForEF">Use Spare Core for EF</mat-checkbox>
        </div>
        }


    </div>

</form>

}


